var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-widget',[(_vm.$fetchState.pending)?void 0:_c('t-count-widget',{attrs:{"label":`${_vm.$t('fields.total_applicants')} (${_vm.$t('global.statuses.active')} / ${_vm.$t('fields.total')})`,"icon":"graduation-cap","card":""}},[_vm._v("\n    "+_vm._s(_vm.data.available_count)+" / "+_vm._s(_vm.data.total_count)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }